var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightSizingSavingArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#3DA64F",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00053 12C8.16353 12 8.31653 11.9205 8.41003 11.7865L11.91 6.7865C12.017 6.634 12.029 6.4345 11.944 6.269C11.8575 6.1035 11.687 6 11.5005 6H4.49953C4.31303 6 4.14253 6.1035 4.05603 6.269C3.97103 6.4345 3.98303 6.634 4.09003 6.7865L7.59003 11.7865C7.68353 11.9205 7.83653 12 7.99953 12H8.00053Z",
    fill: "#3DA64F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSizingSavingArrow);
export default __webpack_public_path__ + "static/media/rightSizingSavingArrow.edbed3378675a0d4479db181e548eee9.svg";
export { ForwardRef as ReactComponent };